<div *ngIf="prikaziStranicu" class="container-fluid">
  <h2 class="content-block">PREGLED PO LOTOVIMA</h2>

  <div class="content-block dnevniPlanWrapper">
    <div class="selectDates">
      <div class="odabirDatuma">
        <label>Datum od:</label>
        <dx-date-box
          [(value)]="datumOd"
          [(max)]="datumDo"
          pickerType="calendar"
          displayFormat='dd.MM.yyyy.'
          width="200"
          (onValueChanged)="onValueChangedDatumOd($event)"
        >
        </dx-date-box>
      </div>
      <div class="odabirDatuma" style="margin-right: 30px">
        <label>Datum do:</label>
        <dx-date-box
          [(value)]="datumDo"
          [(min)]="datumOd"
          pickerType="calendar"
          displayFormat='dd.MM.yyyy.'
          width="200"
          (onValueChanged)="onValueChangedDatumDo($event)"
        >
        </dx-date-box>
      </div>
      <div class="odabirDatuma" style="margin-right: 30px">
        <div class="selectDropdown">
          <label>Smjena:</label>
          <dx-select-box
            [disabled]="false"
            [items]="smjene"
            [value]="smjene[0].id"
            valueExpr="id"
            displayExpr="naziv"
            [width]="120"
            (onValueChanged)="promjenaSmjene($event)"
          >
          </dx-select-box>
        </div>
      </div>
      <!-- <div class="odabirDatuma" style="margin-right:30px;">
            <label>Odaberi proizvod:</label>
            <dx-select-box
                #selectBox
                [dataSource]="sviProizvodi"
                displayExpr="naziv"
                valueExpr="sifra"
                [(value)]="odabraniProizvod"
                placeholder="Odaberi proizvod"
                [searchEnabled]="true"
                [searchExpr]="['sifra', 'naziv']"
                width="500"
                (onValueChanged)="odaberiProizvod($event)">
            </dx-select-box>
        </div> -->
      <div class="odabirDatuma">
        <dx-button
          style="margin-right: 10px"
          stylingMode="outlined"
          text="ULAZ"
          type="success"
          [width]="80"
          (onClick)="prometUlaz(1)"
          [disabled]="pravaZaTrenutniPogled != 2"
        >
        </dx-button>
        <dx-button
          stylingMode="outlined"
          text="IZLAZ"
          type="normal"
          [width]="80"
          (onClick)="prometUlaz(2)"
          [disabled]="pravaZaTrenutniPogled != 2"
        >
        </dx-button>
      </div>
    </div>

    <div class="customTable nadzornaPloca dnevniPlan">
      <dx-data-grid
        #datagrid
        id="tablicaPregledLotovi"
        [dataSource]="tablica"
        [wordWrapEnabled]="true"
        noDataText="{{ poruka }}"
        [showColumnLines]="true"
        keyExpr="idlotpromet"
        [showBorders]="false"
        (onToolbarPreparing)="onToolbarPreparing($event)"
        (onCellPrepared)="onCellPrepared($event)"
        (onSelectionChanged)="onSelectionChanged($event)"
        (onRowClick)="onRowClick($event)"
      >
        <div *dxTemplate="let data of 'naslovTablice'" class="grid-wrapper">
          <div class="naslov">
            <h2 class="mb-0">
              Pregled po lotovima <span *ngIf="ulaz == 1">ULAZ</span><span *ngIf="ulaz == 2">IZLAZ</span>
            </h2>
            <p class="mt-0">Kliknite na red za prikaz detalja</p>
          </div>
        </div>

        <dxo-search-panel
          [visible]="true"
          [width]="210"
          placeholder="Pretraži..."
        >
        </dxo-search-panel>

        <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>

        <dxo-pager
          [showPageSizeSelector]="true"
          [allowedPageSizes]="[10, 20, 30]"
          [showInfo]="true"
        >
        </dxo-pager>

        <dxo-selection mode="single"></dxo-selection>

        <dxo-editing 
          mode="popup" 
          [allowUpdating]="false"
          [allowDeleting]="false">
        </dxo-editing>

        <dxi-column
          dataField="sifra"
          caption="Šifra"
          [width]="100"
          alignment="center"
        ></dxi-column>
        <dxi-column
          dataField="lot"
          caption="LOT"
          [width]="100"
          alignment="center"
        ></dxi-column>
        <dxi-column dataField="naziv" caption="Naziv"></dxi-column>
        <dxi-column
          dataField="datum"
          caption="Datum"
          [width]="150"
          alignment="center"
        ></dxi-column>
        <dxi-column
          dataField="smjena"
          caption="Smjena"
          [width]="100"
          alignment="center"
        ></dxi-column>
        <dxi-column
          *ngIf="ulaz == 1"
          dataField="kolicinaUlaz"
          caption="Ulaz"
          [width]="100"
          alignment="center"
        ></dxi-column>
        <dxi-column
          *ngIf="ulaz == 2"
          dataField="kolicinaIzlaz"
          caption="Izlaz"
          [width]="100"
          alignment="center"
        ></dxi-column>
        <dxi-column
          dataField="dokumentBroj"
          caption="Broj dokumenta"
          [width]="120"
          alignment="center"
        ></dxi-column>
        <dxi-column
          dataField="vrstaDokumenta"
          caption="Vrsta dokumenta"
          [width]="120"
          alignment="center"
        ></dxi-column>
        <dxi-column
          dataField="skladisteSifra"
          caption="Šifra skladišta"
          [width]="100"
          alignment="center"
        ></dxi-column>
        <dxi-column
          dataField="skladisteNaziv"
          caption="Naziv skladišta"
        ></dxi-column>
        
        <dxo-master-detail
          [enabled]="false"
          template="detail">
        </dxo-master-detail>
        <div *dxTemplate="let data of 'detail'">
          <!-- <p *ngIf="!stavke">Dohvaćanje stavki...</p>
          <p *ngIf="stavke.length === 0">Nema stavki!</p>
          <div *ngIf="stavke.length > 0"> -->
          <div *ngIf="isLoading" class="content-block">Učitavanje tablice...</div>
          <div *ngIf="!isLoading">
            <div class="lotStavke">
              <dx-tree-list
                [dataSource]="stavke"
                [wordWrapEnabled]="true"
                keyExpr="idlotpromet"
                [showBorders]="true"
                (onRowRemoved)="obrisiStavku($event)"
                >

                <dxo-editing mode="popup" 
                  [allowUpdating]="false"
                  [allowAdding]="false"
                  [allowDeleting]="true">
                </dxo-editing>

                <dxi-column
                  dataField="sec_user_skenirao"
                  caption="Skenirao"
                  [width]="250">
                </dxi-column>
                <dxi-column
                  dataField="lp_vrijemeulazaiizlazarobe"
                  dataType="datetime"
                  caption="Datum i vrijeme"
                  [width]="200"
                  alignment="center">
                </dxi-column>
                <dxi-column
                  *ngIf="ulaz == 1"
                  dataField="pr_ulaz"
                  caption="Količina"
                  [width]="110">
                </dxi-column>
                <dxi-column
                  *ngIf="ulaz == 2"
                  dataField="pr_izlaz"
                  caption="Količina"
                  [width]="110">
                </dxi-column>
              </dx-tree-list>
            </div>
          </div>
        </div>
      </dx-data-grid>
    </div>
  </div>
</div>
